import { createAction, props } from '@ngrx/store';

const GET_EXPOSED_CLIENT = '[Exposed Rest] Get exposed client';
const SAVE_EXPOSED_CLIENT_STATE = '[Exposed Rest] Save exposed client state';
const SAVE_EXPOSED_COMPONENT_STATE = '[Exposed Rest] Save exposed component state';
const SAVE_EXPOSED_API_STATE = '[Exposed Rest] Save exposed api state';
const SAVE_EXPOSED_CLIENT = '[Exposed Rest] Save Exposed client';
const SET_EXPOSED_CLIENT = '[Exposed Rest] Set Exposed client';
const SET_EXPOSED_CLIENT_TABLE = '[Exposed Rest] Set Exposed client Table';
const DELETE_EXPOSED_CLIENT = '[Exposed Rest] Delete Exposed client';
const DELETE_EXPOSED_CLIENT_STATE = '[Exposed Rest] Delete Exposed client state';
const GET_EXPOSED_COMPONENT = '[Exposed Rest] Get exposed Functional Component';
const GET_EXPOSED_COMPONENT_CLIENT_ID = '[Exposed Rest] Get exposed Component by Client Id';
const SET_EXPOSED_COMPONENT_CLIENT_ID = '[Exposed Rest] Set exposed Component by Client Id';
const SAVE_EXPOSED_COMPONENT = '[Exposed Rest] Save Exposed Functional Component';
const SET_EXPOSED_COMPONENT = '[Exposed Rest] Set Exposed Functional Component';
const SET_EXPOSED_COMPONENT_TABLE = '[Exposed Rest] Set Exposed Functional Component Table';
const DELETE_EXPOSED_COMPONENT = '[Exposed Rest] Delete Exposed Functional Component';
const DELETE_EXPOSED_COMPONENT_STATE = '[Exposed Rest] Delete Exposed Functional Component state';
const GET_EXPOSED_API = '[Exposed Rest] Get exposed API';
const GET_EXPOSED_API_COMPONENT_ID = '[Exposed Rest] Get exposed API by component id';
const SET_EXPOSED_API_COMPONENT_ID = '[Exposed Rest] Set exposed API by component id';
const SAVE_EXPOSED_API = '[Exposed Rest] Save exposed API';
const SET_EXPOSED_API = '[Exposed Rest] Set exposed API';
const SET_NEW_EXPOSED_APIS = '[Exposed Rest] Set newly exposed APIs';
const DELETE_EXPOSED_API = '[Exposed Rest] Delete exposed API';
const DELETE_EXPOSED_API_STATE = '[Exposed Rest] Delete exposed API state';
const SAVE_EXPOSED_API_BATCH = '[Exposed Rest] Save exposed API batch';
const GET_EXPOSED_REST_ALL_DETAILS = '[Exposed Rest] Get all exposed rest details';
const GET_EXPOSED_API_CLIENT_ID = '[Exposed Rest] get Api by ClientId';
const SET_EXPOSED_API_CLIENT_ID = '[Exposed Rest] set api by client';
const GET_CLIENT_AUTOSUGGEST = '[Exposed Rest] Get Client Autosuggest';
const SET_CLIENT_AUTOSUGGEST = '[Exposed Rest] Set Client Autosuggest';
const GET_COMPONENT_AUTOSUGGEST = '[Exposed Rest] Get Component Autosuggest';
const SET_COMPONENT_AUTOSUGGEST = '[Exposed Rest] Set Component Autosuggest';
const GET_API_AUTOSUGGEST = '[Exposed Rest] Get API Autosuggest';
const SET_API_AUTOSUGGEST = '[Exposed Rest] Set API Autosuggest';
const GET_CLIENT_ADVANCE_SEARCH = '[Exposed Rest] Get Client  Advance Search';
const SET_CLIENT_ADVANCE_SEARCH = '[Exposed Rest] Set Client  Advance Search';
const GET_COMPONENT_ADVANCE_SEARCH = '[Exposed Rest] Get Component  Advance Search';
const SET_COMPONENT_ADVANCE_SEARCH = '[Exposed Rest] Set Component  Advance Search';
const GET_API_ADVANCE_SEARCH = '[Exposed Rest] Get API  Advance Search';
const SET_API_ADVANCE_SEARCH = '[Exposed Rest] Set API Advance Search';

const getExposedClient = createAction(GET_EXPOSED_CLIENT, props<{ apiConstants: any }>());

const setExposedClient = createAction(SET_EXPOSED_CLIENT, props<{ exposedClient: any }>());

const setExposedClientTable = createAction(SET_EXPOSED_CLIENT_TABLE, props<{ exposedClientTable: any }>());

const saveExposedClient = createAction(SAVE_EXPOSED_CLIENT, props<{ saveAPiConstants: any; exposedClientData: any }>());

const saveExposedClientState = createAction(
  SAVE_EXPOSED_CLIENT_STATE,
  props<{ success: boolean; exposedClient: any }>()
);

const saveExposedComponentState = createAction(
  SAVE_EXPOSED_COMPONENT_STATE,
  props<{ success: boolean; exposedComponent: any }>()
);

const saveExposedApiBatchState = createAction(
  SAVE_EXPOSED_API_STATE,
  props<{ success: boolean; exposedApiBatch: any }>()
);

const deleteExposedClient = createAction(DELETE_EXPOSED_CLIENT, props<{ deleteApiConstants: any; ids: any }>());

const deleteExposedClientState = createAction(DELETE_EXPOSED_CLIENT_STATE, props<{ success: boolean; ids: any }>());

const getExposedClientAutoSuggest = createAction(GET_CLIENT_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setExposedClientAutosuggest = createAction(SET_CLIENT_AUTOSUGGEST, props<{ clientAutosuggestResults: any }>());

const getExposedClientAdvanceSearch = createAction(GET_CLIENT_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setExposedClientAdvanceSearch = createAction(
  SET_CLIENT_ADVANCE_SEARCH,
  props<{ clientAdvanceSearchtResults: any }>()
);

const getExposedComponentAutoSuggest = createAction(GET_COMPONENT_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setExposedComponentAutosuggest = createAction(
  SET_COMPONENT_AUTOSUGGEST,
  props<{ componentAutosuggestResults: any }>()
);

const getExposedComponentAdvanceSearch = createAction(GET_COMPONENT_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setExposedComponentAdvanceSearch = createAction(
  SET_COMPONENT_ADVANCE_SEARCH,
  props<{ componentAdvanceSearchRsults: any }>()
);

const getExposedApiAutoSuggest = createAction(GET_API_AUTOSUGGEST, props<{ getApiConstants: any }>());

const setExposedApiAutosuggest = createAction(SET_API_ADVANCE_SEARCH, props<{ apiAutosuggestResults: any }>());

const getExposedApiAdvanceSearch = createAction(GET_API_ADVANCE_SEARCH, props<{ getApiConstants: any }>());

const setExposedApiAdvanceSearch = createAction(SET_API_AUTOSUGGEST, props<{ apiAdvanceSearchResults: any }>());

const setDeleteExposedClient = createAction(DELETE_EXPOSED_CLIENT_STATE, props<{ deletedClient: boolean }>());

const getExposedComponent = createAction(GET_EXPOSED_COMPONENT, props<{ apiConstants: any; appId: any }>());

const saveExposedComponent = createAction(
  SAVE_EXPOSED_COMPONENT,
  props<{ saveAPiConstants: any; exposedComponentData: any }>()
);

const setExposedComponentTable = createAction(SET_EXPOSED_COMPONENT_TABLE, props<{ exposedComponentTable: any }>());

const setExposedComponent = createAction(SET_EXPOSED_COMPONENT, props<{ exposedComponent: any }>());

const deleteExposedComponent = createAction(DELETE_EXPOSED_COMPONENT, props<{ deleteApiConstants: any; ids: any }>());

const setDeleteExposedComponent = createAction(DELETE_EXPOSED_COMPONENT_STATE, props<{ deletedComponent: any }>());

const getExposedApi = createAction(GET_EXPOSED_API, props<{ apiConstants: any; appId: any }>());

const getExposedComponentByClientId = createAction(
  GET_EXPOSED_COMPONENT_CLIENT_ID,
  props<{ getExposedComponentByClientIdApi: any; params: any }>()
);

const setComponentByClientId = createAction(
  SET_EXPOSED_COMPONENT_CLIENT_ID,
  props<{ exposedComponentByClient: any }>()
);

const getExposedAPIByComponentId = createAction(
  GET_EXPOSED_API_COMPONENT_ID,
  props<{ getExposedAPIByComponentIdApi: any; params: any }>()
);

const getExposedAPIByClientId = createAction(GET_EXPOSED_API_CLIENT_ID, props<{ apiConstants: any; params: any }>());

const setAPIByComponentId = createAction(
  SET_EXPOSED_API_COMPONENT_ID,
  props<{ componentId: any; exposedAPIByComponent: any }>()
);

const setAPIByClientId = createAction(SET_EXPOSED_API_CLIENT_ID, props<{ clientId: any; exposedAPIByClient: any }>());

const saveExposedApi = createAction(SAVE_EXPOSED_API, props<{ saveAPiConstants: any; exposedApiData: any }>());

const saveExposedApiBatch = createAction(
  SAVE_EXPOSED_API_BATCH,
  props<{ saveAPiConstants: any; exposedApiDataBatch: any }>()
);

const setExposedApi = createAction(SET_EXPOSED_API, props<{ exposedApi: any }>());

const setNewlyExposedApis = createAction(SET_NEW_EXPOSED_APIS, props<{ newlyExposedApiTable: any }>());

const deleteExposedApi = createAction(DELETE_EXPOSED_API, props<{ deleteApiConstants: any; ids: any }>());

const setDeleteExposedApi = createAction(DELETE_EXPOSED_API_STATE, props<{ deletedApi: any }>());

const getExposedRestAllDetails = createAction(GET_EXPOSED_REST_ALL_DETAILS, props<{ apiConstants: any }>());

export {
  getExposedClient,
  saveExposedClient,
  setExposedClient,
  setExposedClientTable,
  saveExposedClientState,
  deleteExposedClient,
  deleteExposedClientState,
  getExposedComponent,
  saveExposedComponent,
  setExposedComponent,
  setExposedComponentTable,
  deleteExposedComponent,
  getExposedApi,
  saveExposedApi,
  setExposedApi,
  deleteExposedApi,
  saveExposedApiBatch,
  getExposedAPIByComponentId,
  getExposedComponentByClientId,
  setComponentByClientId,
  setAPIByComponentId,
  setNewlyExposedApis,
  setDeleteExposedClient,
  setDeleteExposedComponent,
  setDeleteExposedApi,
  getExposedRestAllDetails,
  getExposedAPIByClientId,
  setAPIByClientId,
  getExposedComponentAutoSuggest,
  setExposedComponentAutosuggest,
  getExposedApiAutoSuggest,
  setExposedApiAutosuggest,
  getExposedClientAutoSuggest,
  setExposedClientAutosuggest,
  getExposedComponentAdvanceSearch,
  setExposedComponentAdvanceSearch,
  getExposedApiAdvanceSearch,
  setExposedApiAdvanceSearch,
  getExposedClientAdvanceSearch,
  setExposedClientAdvanceSearch,
  saveExposedComponentState,
  saveExposedApiBatchState
};
